import React from 'react';
import hexrgb from 'hex-rgb';

import {
	KEY_EMAIL_1,
	KEY_EMAIL_2,
	KEY_GITHUB,
	KEY_LARGE,
	KEY_LINKEDIN,
	KEY_LOCATION,
	KEY_NORMAL,
	KEY_PHONE,
	KEY_PORTFOLIO,
	KEY_STOPSTALK
} from "../../Constants/Constants";
import {Alert} from 'reactstrap';
import posed from "react-pose/lib/index";

export const isLink = (data) => {
	return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(data);
	//return data.indexOf('@') > -1;
};

export const isEmail = (data) => {
	return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(data)
};

export const LinkComponent = ({link, anchor, print, styles, icon, isIconBefore}) => {
	let printclass = print ? null : "no-print";
	let classes = [printclass].join(" ");
	let span = icon ? <span className={icon} style={isIconBefore ? {marginRight: "0.2rem"} : {marginLeft: "0.2rem"}}></span> : null;
	// //console.log(icon);
	// let linkStyle = Object.assign({textDecoration: "none"}, styles);
	let linkStyle = Object.assign({
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		width: "max-content"
	}, styles);

	// linkStyle = icon ? Object.assign({textDecoration: "none"}, linkStyle) : linkStyle;

	if (isEmail(link)) {
		link = "mailto:" + link;
	}

	return (
		<a href={link} target="_blank" rel="noopener noreferrer" className={classes}
			 style={linkStyle}> {isIconBefore && span} {anchor} {!isIconBefore && span} </a>
	);
};

export class AlertModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: true
		}
	}

	render() {
		return (
			<Alert isOpen={this.state.isOpen} toggle={() => this.setState({isOpen: false})}>
				{this.props.message}
			</Alert>
		);
	}
}

export const getIcon = (KEY, size) => {

	KEY = KEY.replace(/[^a-zA-Z]/, "").toUpperCase();

	let icon = "fa";
	switch (size) {
		case KEY_NORMAL:
			icon += " fa-2x";
			break;
		case KEY_LARGE:
			icon += " fa-3x";
			break;
		default:
			break;
	}
	switch (KEY) {
		case KEY_PHONE:
			icon += " fa-phone";
			break;
		case KEY_EMAIL_1:
		case KEY_EMAIL_2:
			icon += " fa-envelope-o";
			break;
		case KEY_LOCATION:
			icon += " fa-map-marker";
			break;
		case KEY_LINKEDIN:
			icon += " fa-linkedin-square";
			break;
		case KEY_GITHUB:
			icon += " fa-github-square";
			break;
		case KEY_PORTFOLIO:
			icon += " fa-briefcase";//" fa-link";
			break;
		case KEY_STOPSTALK:
			icon += " fa-stopstalk";//" fa-link";
			break;

		// case KEY_PHONE:
		// 	return "fa fa-phone";
		// case KEY_PHONE:
		// 	return "fa fa-phone";
		default:
			break;
	}
	return icon;
};

const ScaleUpOnHover = posed.div({
	hoverable: true,
	init: {scale: 1},
	hover: {scale: 1.2}
});


export const toRGBA = (color, alpha=0.1) => {
	color = hexrgb(color);
	return `rgba(${color.red},${color.green},${color.blue}, ${alpha})`;
};